/* Terraloo Sleek — single-open accordion groups */
(function () {
  'use strict';

  document.querySelectorAll('[data-tls-accordion]').forEach(function (group) {
    var items = Array.from(group.children).filter(function (el) {
      return el.tagName === 'DETAILS';
    });
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });
})();
